import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import WorkList from 'components/WorkList';

import useCollaborators from 'hooks/useCollaborators';
import useUserIdentity from 'hooks/useUserIdentity';
import useFHRequest from 'hooks/useFHRequest';
import useAuth from 'hooks/useAuth';
import useRoles from 'hooks/useRoles';
import useWorkKey from 'hooks/useWorkKey';
// import getIcon from 'utils/getIcon';
import { WorkItemType } from 'components/WorkListItem';
import {CollabsListTitle} from 'components/CollabsListRoute';


const ClaimedWorkList = observer(( { paged, status }: { paged: boolean, status: string }) => {
    const {
        fetchIdentityCollaborators,
        activeCollaborators,
        snoozedCollaborators,
        archivedCollaborators } = useCollaborators();
    const {
        fetchListByStatus,
        getListByStatus } = useFHRequest();
    const workKey = useWorkKey();

    const { currentUser } = useAuth();
    const [requests, setRequests] = useState([] as WorkItemType[]);
    const [collabs, setCollabs] = useState([] as WorkItemType[]);
	const { currentIdentity } = useUserIdentity();
    const { rolesNames, hasRole } = useRoles();
    const [fetchingSupport, setFetchingSupport] = useState(false);
    const [loadingRequests, setLoadingRequests] = useState(false);
    const [loadingCollabs, setLoadingCollabs] = useState(false);
    const [fetchedCollabs, setFetchedCollabs] = useState(false);

    const _getCollabs = (status: string) => {
        let collabs = []
        if (status === 'active') {
            collabs = activeCollaborators;
        } else if (status === 'snoozed') {
            collabs = snoozedCollaborators;
        } else {
            collabs = archivedCollaborators;
        }

        // Don't show support collabs here unless they are on the
        // support team. If they have support collabs and they're not
        // on support, it means they created it and we'll show it in
        // the `/support` section.
        if(!hasRole('support')) {
            collabs = collabs.filter((c) => c.variant !== 'support');
        }

        return collabs;
    };

    useEffect(() => {
        const i = _getCollabs(status);
        setCollabs(i);
    }, [status, activeCollaborators, snoozedCollaborators, archivedCollaborators]);


    /* load the standard requests */
    useEffect(() => {
        if(loadingRequests) return;
        if(!workKey) return;

        if (['active', 'archived'].includes(status)) {
            setLoadingRequests(true);
            console.log('fetching', status);
            fetchListByStatus(workKey, status)
                .finally(() => {
                    setRequests(getListByStatus(currentIdentity.uuid, currentUser.key, status));
                    setLoadingRequests(false);
                });
        }
        else {
            setLoadingRequests(false);
            setRequests([] as WorkItemType[]);
        }

    }, [fetchListByStatus, getListByStatus, workKey, status]);

    /* load the collabs  */
    useEffect(() => {
        if(fetchedCollabs) return;
        setLoadingCollabs(true);
        fetchIdentityCollaborators(currentIdentity.uuid, 'collab')
            .then(() => {
                const i = _getCollabs(status);
                setCollabs(i);
                console.log('loading collabs collabs.i', i);
                setFetchedCollabs(true);
                setLoadingCollabs(false);
            });
    }, [fetchIdentityCollaborators]);


    /* load the support collabs if we need to */
    useEffect(() => {
        if(!currentIdentity?.uuid)
            return;
        if(fetchingSupport)
            return;

        setFetchingSupport(true);
        if (currentIdentity?.uuid) {
            fetchIdentityCollaborators(currentIdentity.uuid, 'support')
                .finally(() => setFetchingSupport(false));
        }
    }, [currentIdentity, rolesNames]);

    const items = [...collabs, ...requests]
        .sort((a, b) => {
           return a.date_updated > b.date_updated ? -1 : 1
        });

    return <WorkList
               title={<CollabsListTitle status={status} />}
               items={items}
               paged={paged}
               loading={loadingRequests || loadingCollabs} />;

});
export default ClaimedWorkList;
